<div class="min-h-screen flex items-center justify-center bg-[hsl(210_20%_98%)] px-4 py-10">
  <div class="w-full max-w-sm space-y-8">
    <div class="text-center">
      <a routerLink="/" class="inline-block">
        <img src="/images/attestio-logo.png" alt="Attestio" class="h-10 mx-auto mb-6" />
      </a>
      <h1 class="font-display text-2xl font-bold text-[hsl(213_55%_15%)]">
        Nouveau mot de passe
      </h1>
    </div>

    @if (loading()) {
      <p class="text-sm text-center text-[hsl(213_15%_46%)]">Vérification du lien…</p>
    } @else if (!tokenValid()) {
      <div class="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-700 text-center">
        Ce lien de réinitialisation est invalide ou expiré.
      </div>
      <div class="text-center">
        <a routerLink="/login" class="text-secondary text-sm font-medium hover:underline">
          Retour à la connexion
        </a>
      </div>
    } @else {
      <form (ngSubmit)="submit()" class="space-y-4">
        <div>
          <label class="sr-only" for="new-password">Nouveau mot de passe</label>
          <input
            id="new-password"
            type="password"
            placeholder="Nouveau mot de passe"
            class="h-11 w-full rounded-lg border border-[hsl(210_20%_90%)] bg-white px-3 text-[hsl(213_55%_15%)]
                   placeholder:text-[hsl(213_15%_46%)]
                   focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/25"
            [value]="password()"
            (input)="password.set($any($event.target).value)"
            required
            autocomplete="new-password"
          />
        </div>

        @if (password().length > 0 && !isPasswordValid()) {
          <p class="text-xs text-red-600">
            8 caractères minimum, avec majuscule, minuscule, chiffre et caractère spécial.
          </p>
        }

        <div>
          <label class="sr-only" for="confirm-new-password">Confirmer le mot de passe</label>
          <input
            id="confirm-new-password"
            type="password"
            placeholder="Confirmer le mot de passe"
            class="h-11 w-full rounded-lg border border-[hsl(210_20%_90%)] bg-white px-3 text-[hsl(213_55%_15%)]
                   placeholder:text-[hsl(213_15%_46%)]
                   focus:border-secondary focus:outline-none focus:ring-2 focus:ring-secondary/25"
            [value]="confirmPassword()"
            (input)="confirmPassword.set($any($event.target).value)"
            required
            autocomplete="new-password"
          />
        </div>

        @if (confirmPassword().length > 0 && !passwordsMatch()) {
          <p class="text-xs text-red-600">Les mots de passe ne correspondent pas.</p>
        }

        @if (error().length > 0) {
          <p class="text-sm text-red-600 text-center">{{ error() }}</p>
        }

        <button
          type="submit"
          class="w-full h-11 rounded-lg bg-secondary text-secondary-foreground font-semibold cursor-pointer
                 hover:bg-secondary-hover transition-colors duration-150 disabled:opacity-60 disabled:cursor-not-allowed"
          [disabled]="!canSubmit()"
        >
          @if (submitting()) {
            Réinitialisation…
          } @else {
            Mettre à jour le mot de passe
          }
        </button>
      </form>
    }
  </div>
</div>
